import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wellbean-oem-header',
  templateUrl: './wellbean-oem-header.component.html',
  styleUrls: ['./wellbean-oem-header.component.css'],
})
export class WellbeanOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
